"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrayDims = exports.keysAsRowsToObjects = exports.transposeValues = exports.keysAsColsToObjects = exports.objectsKeysAsCol = exports.objectsKeysAsRow = exports.getAllKeys = void 0;
const number_1 = require("../number");
/** return the union of all keys in provided objects */
const getAllKeys = (obs) => obs.reduce((a, ob) => {
    Object.keys(ob).forEach((k) => {
        if (!a.includes(k))
            a.push(k);
    });
    return a;
}, []);
exports.getAllKeys = getAllKeys;
const objectsKeysAsRow = (obs) => (0, exports.getAllKeys)(obs).map((k) => [k, ...obs.map((ob) => ob[k] ?? undefined)]);
exports.objectsKeysAsRow = objectsKeysAsRow;
/** create array with first row as key definition row and fill with rows of the corresponing values for each object in input arrayy */
const objectsKeysAsCol = (obs) => {
    const allKeys = (0, exports.getAllKeys)(obs);
    return [allKeys, ...obs.map((ob) => allKeys.map((k) => ob[k] ?? undefined))];
};
exports.objectsKeysAsCol = objectsKeysAsCol;
/** assuming the first row is all string, treat as key definition row, return objects based on these keys */
const keysAsColsToObjects = (arr) => {
    const xs = [];
    if (arr[0].every((k) => typeof k === 'string')) {
        for (let row = 1; row < arr.length; row++) {
            xs.push(Object.fromEntries(arr[row].map((xv, col) => [arr[0][col], xv || xv === null || (0, number_1.isNumber)(xv) ? xv : undefined])));
        }
    }
    return xs;
};
exports.keysAsColsToObjects = keysAsColsToObjects;
const transposeValues = (values) => {
    const transposed = [];
    values.forEach((row, i) => {
        if (i === 0) {
            row.forEach((col) => {
                transposed.push([col]);
            });
        }
        else {
            row.forEach((col, j) => col && transposed[j]?.push(col));
        }
    });
    return transposed;
};
exports.transposeValues = transposeValues;
const keysAsRowsToObjects = (arr) => {
    const transposed = (0, exports.transposeValues)(arr);
    return (0, exports.keysAsColsToObjects)(transposed);
};
exports.keysAsRowsToObjects = keysAsRowsToObjects;
/** use to get indentation */
const getArrayDims = (arr) => {
    return { rows: arr.length, cols: arr.reduce((a, c) => (c.length > a ? c.length : a), 0) };
};
exports.getArrayDims = getArrayDims;
